import { frontendURL } from '../../../helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from '../../../constants/permissions';
import TasksAgenda from './pages/TasksAgenda.vue';

// Mismo modelo de permisos que Conversaciones/Leads: los agentes con rol custom
// (p.ej. conversation_participating_manage) deben ver la Agenda; la policy
// LeadTaskPolicy limita a sus propias tareas. ['administrator','agent'] los excluía.
const meta = {
  permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  // Forward-compat: el guard de ruta NO lee featureFlag (la protección real es el backend
  // Masifi::EnsureCrmEnabled + el gate del sidebar). Señaliza el flag del módulo CRM.
  featureFlag: 'feature_crm',
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/agenda'),
    name: 'tasks_agenda',
    component: TasksAgenda,
    meta,
  },
];
